import { isNotNilOrEmpty } from '@pcty/utils';
export var getThemeStyle = function (theme, styles) {
    if (isNotNilOrEmpty(styles) && theme.name in styles) {
        // If the dark mode is on and dark mode styles are provided, use those, otherwise use standard theme styles
        return (theme.darkModeDetection && theme.darkMode && styles["".concat(theme.name, "Dark")]) || styles[theme.name];
    }
    return null;
};
